import { Skeleton } from "antd";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const CardDocumentSke = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Skeleton active>
      <div className="card-document"></div>
    </Skeleton>
  );
};
export default CardDocumentSke;
